import "modern-normalize/modern-normalize.css"
import "./src/css/styles.css"
import "./src/assets/custom_styles.css"
import "maplibre-gl/dist/maplibre-gl.css"
import "photoswipe/dist/photoswipe.css"
import "react-toastify/dist/ReactToastify.css"
import React from "react"
import axios from "axios"
import { UserContextProvider } from "contexts/user"
import { ToastContainer } from "react-toastify"

const apiUrl = process.env.GATSBY_API_URL?.replace('http://', 'https://')
axios.defaults.baseURL = apiUrl
axios.defaults.withCredentials = true

if (typeof window !== 'undefined') {
  axios.get("/sanctum/csrf-cookie").catch(() => null)
}

export const wrapRootElement = ({ element }) => (
  <UserContextProvider>
    {element}
    <ToastContainer />
  </UserContextProvider>
)